var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.518,31.549c-0.064-1.055-0.938-1.878-1.996-1.878h-7.043c-1.057,0-1.932,0.823-1.996,1.878l-2.559,41.833 c-0.043,0.699,0.283,1.37,0.86,1.769l6.081,4.196C47.206,79.582,47.603,79.7,48,79.7s0.794-0.118,1.136-0.354l6.081-4.196 c0.577-0.398,0.903-1.069,0.86-1.769L53.518,31.549z M48,75.271l-4.016-2.771l2.375-38.828h3.28l2.376,38.828L48,75.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.375,26.536c0.183,0.94,1.006,1.619,1.963,1.619h7.324c0.958,0,1.781-0.679,1.963-1.619l1.525-7.855 c0.114-0.586-0.04-1.193-0.42-1.654c-0.38-0.46-0.945-0.728-1.543-0.728H42.813c-0.597,0-1.163,0.267-1.543,0.728 c-0.38,0.461-0.534,1.067-0.42,1.654L42.375,26.536z M50.762,20.3l-0.749,3.855h-4.026L45.239,20.3H50.762z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTie);
export default __webpack_public_path__ + "static/media/tie.51c9f466005f15ae01359d284acc47b6.svg";
export { ForwardRef as ReactComponent };